import $ from 'jquery';
import { getScrollTop } from '../utilities/get-scroll';
import passiveSupported from '../utilities/passive-event-supported';

var headerHeight = $('.c-header').outerHeight(true);
var headerBottomHeight = $('.c-header .c-header__bottom').outerHeight(true);
var headerOffset = headerHeight - headerBottomHeight;

const $headerBottom = $( '.c-header__bottom' );
let stickTrigger = $( window ).width() < 768 ? 0 : headerOffset;
let isSticky = false;

const stick = function() {
	if ( isSticky ) {
		return;
	}

	isSticky = true;
	$headerBottom.addClass( 'is-sticky' );
};

const unstick = function() {
	if ( ! isSticky ) {
		return;
	}

	isSticky = false;
	$headerBottom.removeClass( 'is-sticky' );
};

// Hide notification banner and set cookie
$('.c-notification__close').on('click', function (e) {
	e.preventDefault();
	$('.c-notification').remove();
	var postId = $(this).attr("data-post-id");
	if (postId == null) {
		var cookieName = 'notification_banner_closed';
	} else {
		var cookieName = 'notification_banner_' + postId + '_closed';;
	}
	Cookies.set(cookieName, '1', { expires: 30 });
});
